package com.jingfangpai.medicalRecord.model

import com.jingfangpai.common.orm.mapping.MedicalRecordDiagnosisSuggestion
import com.jingfangpai.syndrome.model.SyndromeIndicationSignSymptomDetail
import kotlinx.serialization.Serializable

@Serializable
class MedicalRecordDiagnosisSuggestionDto: MedicalRecordDiagnosisSuggestion() {
    var syndromeId:String?=null
    var syndromeName:String?=null
    var syndromeIndicationName:String?=null
    var syndromeIndicationDescription:String?=null
    var rejectedBy:MedicalRecordDiagnosisRejectedBy? = null
    var votedBy:MedicalRecordDiagnosisVotedBy? = null
    var ignored:Array<SyndromeIndicationSignSymptomDetail> = arrayOf()

}

@Serializable
data class MedicalRecordDiagnosisRejectedBy(var oneIsTooMuchButFound:Array<SyndromeIndicationSignSymptomDetail> = arrayOf(),
                                            var mustBeFoundButNotFound:Array<SyndromeIndicationSignSymptomDetail> = arrayOf())
@Serializable
data class MedicalRecordDiagnosisVotedBy(var oneIsEnoughAndFound:Array<SyndromeIndicationSignSymptomDetail> = arrayOf(),
                                         var mustBeFoundAndFound:Array<SyndromeIndicationSignSymptomDetail> = arrayOf(),
                                         var optionalAndFound:Array<SyndromeIndicationSignSymptomDetail> = arrayOf())